import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import {
  Autocomplete,
  CircularProgress,
  TextField,
  Alert,
} from "@mui/material";
import axios from "axios";

const AirlineSelection = ({ control }) => {
  const [airlines, setAirlines] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchAirlines = async () => {
      try {
        const { data } = await axios.get(`/travelservice/travelservice`);

        if (
          Array.isArray(data) &&
          data.every(
            (item) =>
              typeof item.name === "string" &&
              item.name &&
              typeof item.code === "string" &&
              item.code
          )
        ) {
          setAirlines(data);
        } else {
          throw new Error(
            "Unexpected data format: Airlines data should be an array of objects with valid 'name' and 'code'."
          );
        }
      } catch (error) {
        console.error("Failed to fetch airlines", error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAirlines();
  }, []);

  return (
    <>
      {isError ? (
        <Alert severity="error">
          Failed to load airlines. Please try again later.
        </Alert>
      ) : (
        <Controller
          name="airline"
          control={control}
          render={({ field }) => (
            <Autocomplete
              {...field}
              options={airlines}
              getOptionLabel={(option) => option?.name || ""}
              onChange={(_, value) => field.onChange(value)}
              isOptionEqualToValue={(option, value) =>
                option?.code === value?.code
              }
              loading={isLoading}
              renderOption={(props, option) => (
                <li {...props} key={option.code}>
                  {option.name}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Airline Preference"
                  variant="outlined"
                  placeholder="Select an airline"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {isLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                  error={isError}
                  helperText={isError ? "Failed to load airlines" : ""}
                />
              )}
              value={field.value || null}
            />
          )}
        />
      )}
    </>
  );
};

export default AirlineSelection;
